// Persistent per-device identifier stored in localStorage.
// Used by the backend to prevent free-trial abuse via phone-hotspot
// (different IP) switching. The same device keeps the same id across networks.
// This is NOT a privacy concern: it never leaves the device except as an
// anonymous string sent only to our own server, and contains no PII.

const KEY = "poodletalk_device_id";

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      // Use crypto.randomUUID if available, otherwise a simple fallback
      // (older Safari versions on iOS 14 don't have randomUUID).
      id = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `pt_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Private mode / disabled storage → fall back to a session-scoped id
    return `pt_session_${Math.random().toString(36).slice(2, 11)}`;
  }
}
